import React from "react";
import "./DeletepopupPage.css";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function DeletepopupPage(props) {
  const { t } = useTranslation();
  const cancelDelete = () => {
    props.setDeleteModal(false);
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    await props.itemDelete();
    props.setDeleteModal(false);
  };

  return (
    <Modal
      className="delete_popup_modal"
      show={props.deleteModal}
      keyboard={false}
      restoreFocus={false}
      centered
    >
      <Modal.Body>
        {/* {props.children} */}
        <div className="text-center body-content">
          <div className="close-circle">
            <i className="icon-close" />
          </div>
          <h5 className="header-title mt-4 w300">{props?.deleteInfo?.title}</h5>
          <p className="">
            {props?.deleteInfo?.sub_title}{" "}
            <strong className="pr-color">{props?.deleteInfo?.name}</strong>{" "}
          </p>
          <div className="footer_action">
            <button onClick={() => cancelDelete()} className="cancel-btn w-100">
              {props?.deleteInfo?.type === "order" ? t('pages.add_delivery.no') : t('pages.cancel')}
            </button>
            <button onClick={(e) => deleteItem(e)} className="btn-submit w-100">
              {props?.deleteInfo?.type === "order" ? t('pages.add_delivery.yes') : t('pages.delete')}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
export default DeletepopupPage;
